export const EstadoConsulta = {
    ABIERTO: "ABIERTO",
    RESUELTA:"RESUELTA",
}